(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1917],{

/***/ 92332:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'spinner';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f110';
var svgPathData = 'M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LM = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 34977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discount-tire",
      function () {
        return __webpack_require__(2115);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H4": function() { return /* binding */ YelpButton; },
/* harmony export */   "Ig": function() { return /* binding */ ButtonOutline; },
/* harmony export */   "Op": function() { return /* binding */ ViewAllCitiesButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export LearnMoreButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:bg-green-300 disabled:cursor-not-allowed";
    var baseClassName = "inline-block justify-center bg-lime hover:bg-green-600 text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};
var LearnMoreButton = function(param) {
    var children = param.children;
    var baseClassName = "ml-1 inline-block justify-center bg-blue-900 text-white text-sm px-2 rounded";
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(baseClassName),
        children: children
    });
};
var ButtonOutline = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "opacity-50 cursor-not-allowed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: "".concat(className, " border-primary hover:text-white border inline-block justify-center bg-transparent hover:bg-primary text-primary py-2 text-lg font-semibold px-5 rounded ").concat(disabled ? disabledClassName : "")
    }, rest), {
        children: children
    }));
};
var YelpButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block w-full md:w-auto  border-gray-800 border justify-center bg-transparent hover:bg-gray-800 hover:text-white text-gray-800 py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};
var ViewAllCitiesButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block border-allCitiesGray border justify-center bg-transparent hover:bg-allCitiesGray hover:text-white text-allCitiesGray py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};


/***/ }),

/***/ 55679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useFormAnalytics; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61275);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6069);



var useFormAnalytics = function(newFormValues) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(newFormValues), oldFormValues = ref[0], setOldFormValues = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isInitialLoaded = ref1[0], setInitialLoaded = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), fieldsTracked = ref2[0], setFieldsTracked = ref2[1];
    //TODO we should handle this better here
    var formName = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .propOr */ .Uth)("unknown", "form-name", newFormValues);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        try {
            if (isInitialLoaded) {
                var diffValues = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .fromPairs */ .Pen)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .difference */ .e50)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .toPairs */ .Zpf)(newFormValues), (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .toPairs */ .Zpf)(oldFormValues)));
                var fieldChanged = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .head */ .YMb)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .keys */ .XPQ)(diffValues));
                // detect undefined field and do not send undefined
                if ((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .not */ .ffD)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .includes */ .q9t)(fieldChanged, fieldsTracked)) && fieldChanged !== undefined) {
                    setFieldsTracked((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .concat */ .zoF)(fieldsTracked, [
                        fieldChanged
                    ]));
                    // Log to GA
                    (0,_util_util__WEBPACK_IMPORTED_MODULE_2__/* .sendGAEvent */ .Nf)("fieldChanged", String(fieldChanged), String(formName)).then((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)(""));
                }
                setOldFormValues(newFormValues);
            } else {
                setInitialLoaded(true);
            }
        } catch (e) {
            console.error({
                e: e
            });
        }
    }, [
        oldFormValues,
        newFormValues,
        isInitialLoaded,
        fieldsTracked,
        formName
    ]);
};


/***/ }),

/***/ 2115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ discount_tire; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./public/img/nubrakes-logo.svg
var nubrakes_logo = __webpack_require__(32452);
;// CONCATENATED MODULE: ./public/img/discount-tire-logo.png
/* harmony default export */ var discount_tire_logo = ({"src":"/_next/static/media/discount-tire-logo.4157d981.png","height":307,"width":1022,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEWPHBwvGBmjISSoISWuISWiICUqGxs5uD+lAAAAB3RSTlMNWKy6y3xxKgTTmgAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGFiZmJiZmFlYGBgZGRjZGAAAAGBACO5ace3AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/img/nubrakes-discount@lighter.png
/* harmony default export */ var nubrakes_discount_lighter = ({"src":"/_next/static/media/nubrakes-discount@lighter.a82dcec6.png","height":1379,"width":2000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAOVBMVEVKSkk7ODgxMjVKZHNYanOHiYkuVGpAQEBLOTN+gYM6KSR0eHllb3RaJhdAW24wTWFdXFyJaF1pVlBTC6dIAAAACXRSTlP+/////////v4HKoILAAAACXBIWXMAAC4jAAAuIwF4pT92AAAANElEQVR4nAXBBwKAIAwEsOuULlD//1gSbHfX6gMRVWk9qDCL6I0Is3r/D8TMOTN4AKKVeQEpgQF81JrkfgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./src/util/util.tsx
var util = __webpack_require__(6069);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faSpinner.js
var faSpinner = __webpack_require__(92332);
// EXTERNAL MODULE: ./src/hooks/useFormAnalytics.tsx
var hooks_useFormAnalytics = __webpack_require__(55679);
// EXTERNAL MODULE: ./src/components/Button.tsx
var components_Button = __webpack_require__(68663);
;// CONCATENATED MODULE: ./src/components/Forms/ScheduleServiceMultiStep/Wizard.tsx












var Wizard = function(props) {
    var initialValues = props.initialValues, onSubmit = props.onSubmit, formPages = props.formPages;
    var ref = useState(0), page = ref[0], setPage = ref[1];
    var activePage = formPages[page].element;
    var length = formPages.length;
    var validationSchema = formPages[page].validationSchema;
    var goNextPage = function() {
        setPage(page + 1);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "text-left text-black",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "text-center sm:mb-1",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "mb-1",
                        children: "Get A Free Quote Now"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mt-0 text-base lg:leading-none leading-tight mb-6 md:mb-4",
                        children: "Our repair experts will send you a quote in under 5 minutes."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                initialValues: initialValues,
                enableReinitialize: false,
                validationSchema: validationSchema,
                onSubmit: onSubmit,
                children: function(props) {
                    return /*#__PURE__*/ _jsx(InnerForm, _object_spread_props(_object_spread({}, props), {
                        activePage: activePage,
                        goNextPage: goNextPage,
                        page: page,
                        length: length
                    }));
                }
            })
        ]
    });
};
var InnerForm = function(props) {
    var values = props.values, isSubmitting = props.isSubmitting, isValid = props.isValid, page = props.page, activePage = props.activePage, goNextPage = props.goNextPage, length = props.length, setFieldValue = props.setFieldValue;
    useFormAnalytics(values);
    return /*#__PURE__*/ _jsxs(Form, {
        name: "scheduleServiceWizard",
        children: [
            /*#__PURE__*/ _jsx(Field, {
                type: "hidden",
                name: "form-name",
                value: "scheduleServiceWizard"
            }),
            /*#__PURE__*/ _jsx(Field, {
                type: "hidden",
                name: "email"
            }),
            /*#__PURE__*/ React.createElement(activePage, props),
            /*#__PURE__*/ _jsx("div", {
                className: "px-2 md:px-6",
                children: page === length - 1 ? /*#__PURE__*/ _jsx(SubmitButton, {
                    onClick: function() {
                        setFieldValue("referrerSource", document.referrer, false);
                    },
                    isSubmitting: isSubmitting
                }) : /*#__PURE__*/ _jsx(Button, {
                    disabled: !isValid,
                    className: "w-full py-3",
                    onClick: /*#__PURE__*/ _async_to_generator(function() {
                        return _ts_generator(this, function(_state) {
                            if (window["dataLayer"]) {
                                window["dataLayer"].push({
                                    event: "nextClicked"
                                });
                            }
                            goNextPage();
                            return [
                                2
                            ];
                        });
                    }),
                    children: "Next"
                })
            })
        ]
    });
};
var SubmitButton = function(param) {
    var isSubmitting = param.isSubmitting, buttonText = param.buttonText, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.zx, {
        className: "w-full py-3",
        onClick: typeof onClick === "function" ? onClick : undefined,
        disabled: isSubmitting,
        type: "submit",
        id: "submit-btn",
        children: isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: faSpinner/* faSpinner */.LM,
            spin: true
        }) : buttonText ? buttonText : "Get Free Quote"
    });
};

// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 14 modules
var lib = __webpack_require__(59397);
// EXTERNAL MODULE: ./src/components/clients/new-backend.client.ts
var new_backend_client = __webpack_require__(36826);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Forms/DiscountTireForm.tsx






function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        mutation dt($discountTireContactUsInput: DiscountTireContactUsInput!) {\n          discountTireContactUs(discountTireContactUsInput: $discountTireContactUsInput) {\n            name\n            email\n            phoneNumber\n            metro\n            inquiry\n            appointmentRequestDate\n            dtAccountNumber\n          }\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
var schema = es/* object */.Ry({
    name: es/* string */.Z_().required("Required"),
    email: es/* string */.Z_().email().required("Required"),
    phoneNumber: es/* string */.Z_().matches(phoneRegExp, {
        message: "Invalid Phone Number"
    }).required("Required"),
    metro: es/* string */.Z_().required("Required"),
    inquiry: es/* string */.Z_().min(1).required("Required"),
    dtAccountNumber: es/* string */.Z_(),
    appointmentRequestDate: es/* date */.hT()
}).required();
function DiscountTireForm() {
    var something = (0,router.useRouter)();
    var ref = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema)
    }), handleSubmit = ref.handleSubmit, control = ref.control, isSubmitting = ref.formState.isSubmitting;
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            new_backend_client/* newBackendClient.mutate */.t.mutate({
                                variables: {
                                    discountTireContactUsInput: data
                                },
                                mutation: (0,lib/* default */.ZP)(_templateObject())
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            something.push("/discount-tire-success")
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-1 gap-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    type: "text",
                    control: control,
                    label: "Discount Tire Account Number",
                    name: "dtAccountNumber",
                    required: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    type: "text",
                    control: control,
                    label: "Name",
                    name: "name",
                    required: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    control: control,
                    type: "email",
                    label: "Email",
                    name: "email",
                    required: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    control: control,
                    type: "phoneNumber",
                    name: "phoneNumber",
                    required: true,
                    label: "Phone Number"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    control: control,
                    label: "Metro/City",
                    name: "metro",
                    required: true,
                    type: "select",
                    options: [
                        "Not Listed",
                        "Austin",
                        "Houston",
                        "Dallas",
                        "San Antonio",
                        "Atlanta",
                        "Nashville"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    control: control,
                    label: "Service Inquiry",
                    description: "How can we help? Please provide a description of the services you are looking for. Please also provide a list of vehicles you would like serviced.",
                    name: "inquiry",
                    required: true,
                    type: "textarea"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    control: control,
                    type: "datetime-local",
                    name: "appointmentRequestDate",
                    required: false,
                    label: "Appointment Request Date"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                    isSubmitting: isSubmitting,
                    buttonText: "Get A Quote Today!"
                })
            ]
        })
    });
}
function Input(_param) {
    var name = _param.name, control = _param.control, label = _param.label, required = _param.required, _type = _param.type, type = _type === void 0 ? "text" : _type, description = _param.description, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "control",
        "label",
        "required",
        "type",
        "description"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        render: function(param) {
            var field = param.field, fieldState = param.fieldState;
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-gray-700 font-bold",
                        children: label
                    }),
                    required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-red-400",
                        children: " *"
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-gray-500",
                            children: description
                        })
                    }),
                    type === "datetime-local" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,src_object_spread/* default */.Z)({
                        type: type,
                        className: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    }, field)) : type === "textarea" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,src_object_spread/* default */.Z)({
                        className: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    }, field)) : type === "phoneNumber" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        type: "text",
                        className: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    }, field), {
                        onChange: function(e) {
                            var val = (0,util/* normalizePhone */.UK)(e.target.value);
                            field.onChange(val);
                        }
                    })) : type === "select" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("select", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        className: "block w-full mt-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    }, field), {
                        children: rest === null || rest === void 0 ? void 0 : (ref = rest.options) === null || ref === void 0 ? void 0 : ref.map(function(val) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: val,
                                children: val
                            }, val);
                        })
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,src_object_spread/* default */.Z)({
                        type: type,
                        className: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    }, field)),
                    ((ref1 = fieldState.error) === null || ref1 === void 0 ? void 0 : ref1.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-red-500",
                        children: fieldState.error.message
                    })
                ]
            });
        }
    });
}

;// CONCATENATED MODULE: ./src/components/DiscountTire/DiscountTireHeader.tsx






function DiscountTireHeader() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative overflow-hidden min-h-[60vh] pb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    zIndex: -100,
                    top: 0,
                    left: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-8 flex flex-col justify-center align-center w-full h-full min-h-[60vh] ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: nubrakes_discount_lighter,
                        placeholder: "blur",
                        layout: "fill",
                        priority: true,
                        objectFit: "cover",
                        objectPosition: "bottom center",
                        alt: "NuBrakes Discount Tire Header Image"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        zIndex: 1
                    },
                    className: "bg-gray-200 flex flex-row justify-center flex-shrink px-6 rounded-b-xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-2 px-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "Discount Tire Logo",
                                src: discount_tire_logo,
                                priority: true,
                                width: 166,
                                height: 50
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "border-black border-2 my-2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-2 px-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "NuBrakes Logo",
                                src: nubrakes_logo/* default */.Z,
                                priority: true,
                                width: 150,
                                height: 50
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    zIndex: 40
                },
                className: "flex flex-col items-center middle mt-8 text-white [&>*]:z-10 px-",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-4xl lg:text-7xl tracking-wider",
                        children: "Discount Tire"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xl lg:text-4xl tracking-widest",
                        children: "Mobile Fleet Services"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "bg-red-600 p-3 tracking-widest lg:text-xl text-sm",
                        children: "Powered By NuBrakes"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-xl mx-auto p-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-white p-3 rounded-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountTireForm, {})
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/index.mjs
var pro_duotone_svg_icons = __webpack_require__(21702);
;// CONCATENATED MODULE: ./src/pages/discount-tire.tsx







var DiscountTirePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "Discount Tire & NuBrakes | NuBrakes Mobile Fleet Services",
        description: "Eliminate downtime and maximize revenue generation with NuBrakes Mobile Fleet Services. We come to you and work around your schedule 7 days a week! Book now!",
        showFooter: false,
        showGetQuote: false,
        showNavBar: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: "noindex,nofollow"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountTireHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "bg-gray-200 text-center px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Why Choose NuBrakes Fleet Maintenance?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Eliminate downtime and maximize revenue generation with NuBrakes Mobile Fleet Services. We come to you and work around your schedule 7 days a week! Book now!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid lg:grid-cols-4 grid-cols-1 gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:col-start-2 flex flex-col space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_duotone_svg_icons/* faHandHoldingDollar */.VPG,
                                        style: {
                                            color: "f04f23"
                                        },
                                        size: "5x"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Eliminate Downtime and Maximize Revenue"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We come to you. Eliminate the extra time and money it takes to send yourself or an employee to the repair shop."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_duotone_svg_icons/* faCalendarDay */.$nv,
                                        style: {
                                            color: "f04f23"
                                        },
                                        size: "5x"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Repairs Around Your Schedule"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Choose a repair schedule that works around your business operations, or schedule on-demand service as needed"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "NuBrakes Services and Pricing"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "We service Class 1-3 vehicles and are available seven days a week!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row justify-center text-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "list-disc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        "Brake Pad and Rotors Replacement (single Axle) starting at $450",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "list-disc my-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Pad Replacement"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Rotor Replacement"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Caliper Replacement"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Hose Replacement"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Brake Fluid Exchange"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        "Standalone Oil Change;",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "my-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Multiple Vehicles - $80 per gas vehicle (2 or More)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Single Vehicle - $90 per gas vehicle (Single Vehicle Visit)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Diesel Vehicle - $135 per diesel vehicle"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Maintenance Packages (Oil Change, Filter replacements, Inspection) starting at $179"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Cabin Filter Replacement (Add on) starting at $59"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Engine Filter Replacement (Add on) starting at $59"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Wiper Blades (Add on) starting at $50"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Standalone Telematics Installation starting at $99"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Standalone Vehicle Inspections starting at $49"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var discount_tire = (DiscountTirePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2247,2978,4231,7533,2932,9774,2888,179], function() { return __webpack_exec__(34977); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);